const fetchProperty = (obj, relation) => {
  const arr = relation.split('.')
  let result = obj
  arr.forEach(item => {
    result = result[item]
  })
  return result
}

export default fetchProperty
